import React from 'react';

/**
 * Small clickable icon chip used to toggle side panel cards.
 */
function Chip({ title, icon, onClick, chipRef }) {
  return (
    <div className="chip" title={title} role="button" onClick={onClick} ref={chipRef}>
      <div className="chip-icon">
        {icon}
      </div>
    </div>
  );
}

export default Chip;


